import * as React from 'react';
import { connect } from 'react-redux';

export class ScrollToTop extends React.Component<null, null> {

    private scroll() {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        })      
    }
    private boundScroll = this.scroll.bind(this);

    render() {
        return (
            <div className="adage-search-scroll-to-top adage-search-scroll-to-top-hidden">
                <button type="button" onClick={this.boundScroll}>
                    <svg className="svg-icon" aria-hidden="true" focusable="false">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-scroll-to-top" />
                    </svg>
                    <span className="visually-hidden">Scroll to top of page</span>
                </button>
            </div>            
        )
    }

    componentDidMount() {
        let filters = document.querySelector('.adage-search-rail-inner-js') as HTMLElement;
        let filtersHeight = filters.offsetTop + filters.scrollHeight;
        let scrollToToContainer = document.querySelector('.adage-search-scroll-to-top');
        const hiddenClass = 'adage-search-scroll-to-top-hidden';

        function displayScrollToTop(heightConstraint) {
            if (window.pageYOffset > heightConstraint && scrollToToContainer.classList.contains(hiddenClass)) {
                scrollToToContainer.classList.remove(hiddenClass);
            }
            else if (window.pageYOffset < heightConstraint && !scrollToToContainer.classList.contains(hiddenClass)) {
                scrollToToContainer.classList.add(hiddenClass);
            }
        }

        window.addEventListener('scroll', function () {
            if (window.innerWidth > 960) {
                displayScrollToTop(filtersHeight);
            }
            else {
                displayScrollToTop(1250);
            }
        })
    }
}

export const ConnectedScrollToTop = connect(null, null)(ScrollToTop);